import { lazy } from "react";
import { withSuspense } from "./routeHelpers";

const Versions = lazy(
  () => import(/* webpackChunkName: "versions" */ "../Versions/Versions")
);
const Version = lazy(
  () => import(/* webpackChunkName: "versions" */ "../Versions/Version")
);

export default [
  {
    path: "/versions",
    element: withSuspense(Versions),
  },
  {
    path: "/versions/:id",
    element: withSuspense(Version),
  },
];
